module.exports = __webpack_public_path__ + "static/images/containers/ShopView/containers/ShopErrorScreen/images/error-icon.bef74211.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ShopView/containers/ShopErrorScreen/images/error-icon.png
// module id = 3260
// module chunks = 11